import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import * as FC from "@fluentui/react-components";
import { useToast } from "../hooks/useToast";

/**
 * Compatibility landing for the two entry points that used to be cross-tenant write pages:
 * `/field/user` (people, filed under "风场管理" as if a person belonged to a wind farm) and
 * `/system/customers` (customers, with a tenant dropdown inside the form).
 *
 * A bookmark to either must not silently 404, and must not render anything writable. It sends the
 * operator to the tenant list to choose a tenant first — after which the tenant is a property of the
 * URL, not of a form field a stale render can change underneath a request in flight.
 *
 * `replace` is deliberate: the old URL must not stay in history, or Back walks straight into it.
 */
export const TenantScopedEntryRedirect = ({
    message = "请先选择租户，再管理该租户的人员或客户账号。",
    to = "/system/tenants",
}) => {
    const navigate = useNavigate();
    const showToast = useToast();

    useEffect(() => {
        showToast(message, "info");
        navigate(to, { replace: true });
    }, [message, navigate, showToast, to]);

    return (
        <div style={{ padding: 16 }}>
            <FC.Spinner label={message} />
        </div>
    );
};

export default TenantScopedEntryRedirect;
